module.exports = __webpack_public_path__ + "media/images/icons/filled/crown-972193caef31ee63277b702de14257bc.svg";